module.exports = __webpack_public_path__ + "media/images/minimize-fefc12707cc24b53031c12ff4089ea90.svg";